module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var attributes = Html.attributes(_.reduce(_.pick(item, 'id', 'name', 'type'), function(result, value, key) {
    result['data-' + key] = value;
    return result;
}, {}));

    ; __append("\n<li name=\"item\" class='gis-menu-list-item gis-menu-list-item-exp ")
    ; __append(escapeFn( item.classes ))
    ; __append("' ")
    ; __append( attributes )
    ; __append(">\n    <div class='gis-menu-list-root'>\n        <span class=\"icon-drag_handle icon-24 gis-menu-item-handle\"></span>\n		")
    ;  if (item.type == 'group') { 
    ; __append("\n			<label>")
    ; __append( item.html || item.label )
    ; __append("</label>\n		")
    ;  } else { 
    ; __append("\n			<label on-click=\"onItemClick\" ")
    ; __append( attributes )
    ; __append(">\n				<input type='checkbox' state-holder> ")
    ; __append( item.html || item.label )
    ; __append("\n			</label>\n		")
    ;  } 
    ; __append("\n        <div class='gis-menu-list-hdl'>\n            <div></div>\n        </div>\n    </div>\n    <div class='gis-menu-list-inn'>\n        <div name=\"inner\" class='gis-menu-list-inn-wrp'>\n\n            ")
    ; 
                if (_.size(item.colorizers)) { 
    ; __append("\n                <div class=\"gis-layer-styles section\">\n                    <span class=\"control-title\">Цветовая схема</span>\n                    <select on-change=\"onColorizerChange\" class=\"menu-item-colorizer\" name=\"style-name\" ")
    ; __append( attributes )
    ; __append(">\n                        <option>-</option>\n                        ")
    ;  _.each(item.colorizers, function(colorizer, key) {
    ; __append("\n                            <option value=\"")
    ; __append(escapeFn( colorizer.id ))
    ; __append("\"\n                                    ")
    ; __append( Html.attributes({'data-colorizer':colorizer}) )
    ; __append(">")
    ; __append(escapeFn( colorizer.title ))
    ; __append("</option>\n                        ")
    ;  }) 
    ; __append("\n                    </select>\n                </div>\n                ")
    ;  }
            
    ; __append("\n\n\n            ")
    ;  if (!_.isEmpty(item.filters)) { 
    ; __append("\n            <div class=\"gis-layer-styles section\">\n                <span class=\"control-title\">Подписи объектов</span>\n                <select on-change=\"onLabelChange\" class=\"menu-item-label\" name=\"label-name\" ")
    ; __append(escapeFn( attributes ))
    ; __append(">\n                    <option>-</option>\n                    ")
    ;  _.each(item.attributes, function(attribute) {
    ; __append("\n\n                        <option value=\"")
    ; __append(escapeFn( attribute.id ))
    ; __append("\" ")
    ; __append( Html.attributes({ 'data-attribute': attribute }) )
    ; __append(">")
    ; __append(escapeFn( attribute.name ))
    ; __append("</option>\n                    ")
    ;  }) 
    ; __append("\n                </select>\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            <!-- filters based on class attributes -->\n            ")
    ;  if (!_.isEmpty(item.filters)) { 
    ; __append("\n            <div class=\"gis-layer-filters section\" name=\"layer-filters\"></div>\n            ")
    ;  } 
    ; __append("\n\n            <!-- custom styles -->\n            ")
    ;  if (_.size(item.namedStyles)) { 
    ; __append("\n            <div class=\"gis-layer-styles section\">\n                <select class=\"menu-item-style-select\" name=\"style-name\" ")
    ; __append( attributes )
    ; __append(">\n                    ")
    ;  _.each(item.namedStyles, function(style, key) { 
    ; __append("\n                    <option value=\"")
    ; __append(escapeFn( key ))
    ; __append("\">")
    ; __append(escapeFn( style.title ))
    ; __append("</option>\n                    ")
    ;  }) 
    ; __append("\n                </select>\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if (!_.isEmpty(item.mapreports)) { 
    ; __append("\n            <div class=\"gis-layer-mapreports section\">\n                ")
    ;  _.each(item.mapreports, function(report){ 
    ; __append("\n                <div>\n                    <label>\n                        ")
    ; 
                          var data = Html.attributes(_.reduce(report, function(result, value, key) {
                              result['data-' + key] = value;
                              return result;
                          }, {}));
                          
    ; __append("\n                        <input type=\"checkbox\" name=\"show-mapreport\" value=\"")
    ; __append(escapeFn( report.name ))
    ; __append("\" on-change=\"onShowMapReportChange\" ")
    ; __append( data )
    ; __append(" /> ")
    ; __append(escapeFn( report.title ))
    ; __append("\n                    </label>\n                </div>\n                ")
    ;  }) 
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n        </div>\n    </div>\n</li>\n")
  }
  return __output.join("");

}